import { Platform } from "react-native";
import TenantLogo from "components/TenantLogo";
import FanRallyLogo from "components/FanRallyLogo";
import React from "react";

export const resolveLogo = () => {
  if (Platform.OS === "web") {
    return <TenantLogo />;
  } else {
    return <FanRallyLogo width={70} height={70} />;
  }
};
